import React, {
  Component,
  Fragment,
  useEffect,
  useMemo,
  useState,
} from "react";

import users from "../../assets/images/icon_home/user.svg";
import * as API from "../../core/service/api.js";
import {} from "../../core/feature/store";
import * as api_card from "../../core/service/api_card";
import { useAppSelector, useAppDispatch } from "../../core/feature/hooks";
import { Link, Navigate, useLocation, useNavigate } from "react-router-dom";
import Tabs from "../__template/BottomNavComponent";
import "react-lazy-load-image-component/src/effects/blur.css";
import { formatCurrency } from "../../config/global";
import User from "../../core/models/user";
import Config from "../../config/Config";
import { useDispatch } from "react-redux";
import { setToken } from "../../core/feature/token/tokenSlice";
import { removeUser, setUser } from "../../core/feature/user/userSlice";
import { Dialog, Listbox, Switch, Transition } from "@headlessui/react";
import card from "../../assets/images/icon_card/card.svg";
import settingIcon from "../../assets/images/icon_card/setting.svg";
import syncHistory from "../../assets/images/icon_card/sync.svg";
import tkiWhite from "../../assets/images/icon_card/tki-white.svg";
import settingBlackIcon from "../../assets/images/icon_card/setting-black.svg";
import helpIcon from "../../assets/images/icon_card/help.svg";
import TabsMobile from "../__template/TabsMobileComponent";
import CurrencyInput from "react-currency-input-field";
import { t } from "i18next";
import { useTranslation } from "react-i18next";
import PullToRefresh from "react-simple-pull-to-refresh";
import _ from "lodash";
import moment from "moment";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from "react-responsive-carousel";
import CustomApp from "../../core/models/customApp";
import Slider from "react-slick";
import { toast } from "react-toastify";
import { setLoading } from "../../core/feature/config/configSlice";
import { log } from "console";
import { isDarkColor } from "../../config/DarkColorChecker";
const CardMobile = () => {
  const user: User = useAppSelector((state) => state.user.user);
  const [company, setCompany] = useState<any>({});
  const cardData = JSON.parse(String(localStorage.getItem("card")));
  const customApp: CustomApp = useAppSelector(
    (state) => state.customApp.customApp
  );
  const token: String = useAppSelector((state) => state.token.token);
  const [pages, setPage] = useState(0);
  const [lastPage, setLastPage] = useState(0);
  const [data, setData] = useState<any>([]);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const [position, setPosition] = useState(0);
  const [cards, setCards] = useState<any>([]);
  const [lastSync, setlastSync] = useState<any>([]);
  const [stringLastSync, setStringLastSync] = useState<any>([]);
  const [selectedCard, setSelectedCard] = useState<any>({});
  const [tempDaily, setTempDaily] = useState("");
  const [daily, setDaily] = useState(0);
  const [tempLimitMax, setTempLimitMax] = useState("");
  const [limitMax, setLimitMax] = useState(0);
  const [tempCardBalance, setTempCardBalance] = useState("");
  const [cardBalance, setCardBalance] = useState(0);
  const [isUnlimited, setIsUnlimited] = useState(false);
  const [currentUnlimited, setCurrentUnlimited] = useState(false);
  const [showAllDateSync, setshowAllDateSync] = useState(false);
  const [currentUser, setCurrentUser] = useState<any>({});
  let [isOpen, setIsOpen] = useState(false);
  const [isHelpOpen, setIsHelpOpen] = useState(false);
  let [noData, setNoData] = useState(false);
  const [tags, setTags] = useState<any>([]);
  const [selectedTags, setSelectedTags] = useState<any>([]);
  const { t } = useTranslation();

  const env = Config.BaseUrlDev;

  useEffect(() => {
    if (user == undefined) {
      navigate("/login", { replace: true });
    } else {
      getUserData();
      getAllCard();
      getUnlimited();
    }
  }, []);
  useEffect(() => {
    if (location.pathname.split("/")[2] != undefined) {
    }
  }, [location.pathname.split("/")[2]]);

  useEffect(() => {
    setCompany(JSON.parse(localStorage.getItem("company") || ""));
  }, []);

  useEffect(() => {}, []);

  function getImgContent(url: string) {
    return env + "main_a/image/get/" + url + "/pas";
  }

  const getAllCard = async () => {
    dispatch(setLoading(true));
    api_card.getCards().then((res: any) => {
      dispatch(setLoading(false));

      console.log(res.data.length);
      if (res.data.length > 0) {
        if (!localStorage.getItem("card")) {
          localStorage.setItem("card", JSON.stringify(res.data));
        }

        let temp = res.data;
        setCards(temp);

        setSelectedCard(temp[position]);
        setLimitMax(temp[position].limitMax);
        setDaily(temp[position].limitDaily);
        setCardBalance(temp[position].cardBalance);
        getLastSync(temp[position].id);
        setTempLimitMax(getCurrency(temp[position].limitMax));
        setTempDaily(getCurrency(temp[position].limitDaily));
        setTempCardBalance(getCurrency(temp[position].cardBalance));
      }
    });
  };

  function getUserData() {
    api_card.getUser().then((res) => {
      let tempUser = {
        active: res.data.accounts[0].active,
        address: res.data.address,
        banks: res.data.banks,
        callerId: "",
        callerName: "",
        callerTitle: "",
        dateOfBirth: res.data.dateOfBirth,
        email: res.data.email,
        gender: res.data.gender,
        maritalStatus: res.data.maritalStatus,
        name: res.data.name,
        nik: res.data.name,
        note: res.data.note,
        phone: res.data.phone,
        photoUrl: res.data.photoUrl,
        placeOfBirth: res.data.placeOfBirth,
        religion: res.data.religon,
        roles: res.data.accounts[0].roles,
        socmedAccounts: res.data.sosmedAccounts,
        sourceOfFund: res.data.accounts[0].sourceOfFund,
        tags: [],
        transactionUnlimited: res.data.accounts[0].transactionUnlimited,
      };
      let temp = res.data.accounts[0].transactionUnlimited;
      setCurrentUnlimited(temp);
      setIsUnlimited(temp);
      setCurrentUser(tempUser);
    });
  }

  function saveData() {
    let unlimitedChanged = isUnlimited != currentUnlimited;
    let limitChanged =
      selectedCard.cardBalance != cardBalance ||
      selectedCard.limitMax != limitMax ||
      selectedCard.limitDaily != daily;

    if (unlimitedChanged) {
      let temp = currentUser;
      temp.transactionUnlimited = isUnlimited;
      api_card
        .saveUnlimited(temp)
        .then((res: any) => {
          getUserData();
          getAllCard();
          getUnlimited();
        })
        .catch((e) => {});
    }

    if (limitChanged) {
      let temp = selectedCard;
      temp.balance = cardBalance;
      temp.limitMax = limitMax;
      temp.limitDaily = daily;
      console.log(temp);

      api_card
        .saveCard(temp.id, temp)
        .then((res: any) => {
          getUserData();
          getAllCard();
          getUnlimited();
        })
        .catch((e) => {});
    }

    if (unlimitedChanged || limitChanged) {
      var studentCard = _.find(cardData, { id: selectedCard.id });
      console.log(cardData, selectedCard.id);

      var studentCardIndex = _.findIndex(cardData, { id: selectedCard.id });
      var dateSync = [];
      dateSync = studentCard?.dateSync || [];
      dateSync.push(moment().format("YYYY-MM-DD HH:mm"));
      studentCard.dateSync = dateSync;

      _.replace(cardData, cardData[studentCardIndex], studentCard);
      localStorage.setItem("card", JSON.stringify(cardData));
    }

    getLastSync(selectedCard.id);
    closeModal();
  }

  function getUnlimited() {
    let temp = JSON.parse(String(localStorage.getItem("user_redux")))
      .accounts[0].transactionUnlimited;
    setIsUnlimited(temp);
  }

  function closeModal() {
    setIsOpen(false);
  }

  function closeHelpModal() {
    setIsHelpOpen(false);
  }

  function openModal() {
    setIsUnlimited(currentUser.transactionUnlimited);
    setLimitMax(cards[position].limitMax);
    setDaily(cards[position].limitDaily);
    setCardBalance(cards[position].cardBalance);

    setIsOpen(true);
  }

  function openHelpModal() {
    setIsHelpOpen(true);
  }

  function goToSync() {
    navigate(`/digital-card/${cards[position].id}`, {
      state: { syncDate: stringLastSync },
    });
  }

  function numberOnly(str: any) {
    return String(str).replace(/[^0-9.]/g, "");
  }

  function getCurrency(str: any) {
    return formatCurrency(str).replace(",00", "");
  }
  const handleRefresh = async () => {
    getUserData();
    getAllCard();
    getUnlimited();
  };

  function getLastSync(id: any) {
    var studentCard = _.find(cardData, { id: id });

    setlastSync(studentCard?.dateSync);
    if (studentCard?.dateSync) {
      let timeArray = studentCard?.dateSync;
      let sortedTimeArray = timeArray.slice().sort();
      setStringLastSync(sortedTimeArray[sortedTimeArray.length - 1]);
    } else {
      setStringLastSync("");
    }
  }

  function SampleNextArrow(props: any) {
    const { className, style, onClick } = props;
    return (
      <div
        className={className}
        style={{
          display: "block",
          background: "transparent",
          marginRight: 32,
          width: 24,
          height: 24,
          color: "white",
          zIndex: 10,
        }}
        onClick={onClick}
      />
    );
  }

  function SamplePrevArrow(props: any) {
    const { className, style, onClick } = props;
    return (
      <div
        className={className}
        style={{
          display: "block",
          background: "transparent",
          marginLeft: 32,
          width: 24,
          height: 24,
          color: "white",
          zIndex: 10,
        }}
        onClick={onClick}
      />
    );
  }

  var settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    swipeToSlide: true,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    afterChange: function (index: number) {
      setPosition(index);
    },
  };
  useEffect(() => {
    setSelectedCard(cards[position]);
    getLastSync(cards[position]?.id);
    setshowAllDateSync(false);
  }, [position]);

  return (
    <>
      <div className="relative min-h-screen h-full  bg-psp-primary pb-10">
        <div className="bg-white px-8 pt-8 pb-3  sticky top-0 z-50">
          <TabsMobile
            name={`${t("DIGITALCARD.title")}`}
            backUrl={"home"}
          ></TabsMobile>
        </div>
        <PullToRefresh className="text-center" onRefresh={handleRefresh}>
          <div className="text-left min-h-screen h-full mb-6 px-4 py-6 bg-psp-primary top-to-bottom font-montserrat">
            <section className="mt-1">
              {cards?.length == 1 ? (
                <div className="h-full mb-3">
                  <div className="w-full h-full shadow-md rounded-3xl relative">
                    <img src={card} className="h-full w-full relativeca" />
                    <div className="absolute top-0 text-white w-full p-2.5">
                      <div className="w-full mb-4 text-xs font-semibold flex justify-between">
                        <img src={tkiWhite} className=" h-5 pl-1 pt-1" />
                        <div>{cards[0]?.callerName}</div>
                      </div>
                      <div className="text-center">
                        <div className=" font-light">
                          {t("DIGITALCARD.balanceCard")}
                        </div>
                        <div className=" font-bold text-2xl mb-1">
                          {getCurrency(selectedCard?.cardBalance)}
                        </div>
                        <div className=" font-light">NFC ID</div>
                        <div className=" font-medium">{cards[0]?.nfcId}</div>
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="h-full mb-3">
                  <Slider {...settings} className="rounded-sm">
                    {cards.map((item: any, key: number) => (
                      <div className="w-full h-full shadow-md rounded-3xl relative">
                        <img src={card} className="h-full w-full relativeca" />
                        <div className="absolute top-0 text-white w-full z-50 p-2.5">
                          <div className="w-full mb-4 text-xs font-semibold flex justify-between">
                            <img src={tkiWhite} className=" h-5 pl-1 pt-1" />
                            <div>{item?.callerName}</div>
                          </div>
                          <div className="text-center">
                            <div className=" font-light">
                              {t("DIGITALCARD.balanceCard")}
                            </div>
                            <div className=" font-bold text-2xl mb-1">
                              {getCurrency(selectedCard?.cardBalance)}
                            </div>
                            <div className=" font-light">NFC ID</div>
                            <div className=" font-medium">{item?.nfcId}</div>
                          </div>
                        </div>
                      </div>
                    ))}
                    {/* {cards.map((item: any, key: number) => {
                      return (
                        <img src={card} className="h-full w-full relative" />
                      );
                    })} */}
                  </Slider>
                </div>
              )}
              <div className="text-lg font-semibold pb-3">
                {t("DIGITALCARD.info")} :
              </div>
              <div className="rounded-2xl bg-white p-3">
                <table className="w-full">
                  <tr className="hidden">
                    <td>
                      <div className="text-xs">
                        {t("DIGITALCARD.balanceCard")}
                      </div>
                    </td>
                    <td>:</td>
                    <td className="text-right">
                      <div className="text-xs">
                        {getCurrency(selectedCard?.cardBalance)}
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <div className="text-xs">
                        {t("DIGITALCARD.limitAccumulate")}
                      </div>
                    </td>
                    <td>:</td>
                    <td className="text-right">
                      {selectedCard?.limitDaily && (
                        <div className="text-xs">
                          {getCurrency(selectedCard?.limitMax)}
                        </div>
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <div className="text-xs">
                        {t("DIGITALCARD.dailyLimit")}
                      </div>
                    </td>
                    <td>:</td>
                    <td className="text-right">
                      {selectedCard?.limitDaily && (
                        <div className="text-xs">
                          {getCurrency(selectedCard?.limitDaily)}
                        </div>
                      )}
                    </td>
                  </tr>
                  <tr className="items-center">
                    <td>
                      <div className="text-xs">{t("DIGITALCARD.lastSync")}</div>
                    </td>
                    <td>:</td>
                    <td className="text-right">
                      <div>
                        <div>
                          {lastSync
                            ?.reverse()
                            .slice(0, 1)
                            .map((res: any) => (
                              <></>
                            ))}
                          {
                            // lastSync && <span className="text-xs">{lastSync[lastSync.length - 1]}</span>
                          }
                          <span className="text-xs">{stringLastSync}</span>
                        </div>
                        {/* <div hidden={showAllDateSync} className="flex flex-col">
                          {lastSync
                            ?.reverse()
                            .slice(0, 1)
                            .map((res: any) => (
                              <span className="text-xs">{res}</span>
                            ))}
                        </div>
                        <div
                          hidden={!showAllDateSync}
                          className="flex flex-col"
                        >
                          {lastSync?.map((res: any) => (
                            <span className="text-xs">{res}</span>
                          ))}
                        </div>
                        <span
                          hidden={
                            lastSync?.length <= 1 ||
                            lastSync?.length == undefined
                          }
                          className="text-psp-primary text-xs font-medium"
                          onClick={() =>
                            showAllDateSync == false
                              ? setshowAllDateSync(true)
                              : setshowAllDateSync(false)
                          }
                        >
                          {!showAllDateSync ? "Show All" : "Hide"}
                        </span> */}
                      </div>
                    </td>
                  </tr>
                </table>

                <div className="mt-4 hidden">
                  <div className="my-2">
                    <button
                      hidden={!company?.cardSetting?.limitChange}
                      style={{ backgroundColor: customApp?.app_accent_color }}
                      className={`w-full p-2 flex justify-center rounded-md ${
                        isDarkColor(customApp.app_accent_color)
                          ? "text-white"
                          : "text-black"
                      }`}
                      onClick={openModal}
                    >
                      <img
                        src={settingIcon}
                        alt=""
                        className={`mr-2 ${
                          isDarkColor(customApp.app_accent_color)
                            ? ""
                            : "invert"
                        }`}
                      />
                      {t("DIGITALCARD.setLimit")}
                    </button>
                  </div>
                </div>
              </div>
              <div className=" my-3">
                <div className="text-lg font-semibold pb-3">Menu Kartu</div>
                <div className="grid grid-cols-2">
                  <button
                    hidden={!company?.cardSetting?.limitChange}
                    className=" m-1 bg-white rounded-md p-2 flex"
                    onClick={openModal}
                  >
                    <div className=" w-8 h-8 flex justify-center items-center mr-2 rounded-md">
                      <img src={settingIcon} alt="" className={` w-5 h-5`} />
                    </div>
                    <div className=" flex items-center h-8 font-medium text-sm">
                      {t("DIGITALCARD.setLimit")}
                    </div>
                  </button>
                  <button
                    className=" m-1 bg-white rounded-md p-2 flex"
                    onClick={goToSync}
                  >
                    <div className=" w-8 h-8 flex justify-center items-center mr-2 rounded-md">
                      <img src={syncHistory} alt="" className={` w-5 h-5`} />
                    </div>
                    <div className=" flex items-center h-8 font-medium text-sm">
                      {t("DIGITALCARD.syncHistory")}
                    </div>
                  </button>
                  <button
                    className=" m-1 bg-white rounded-md p-2 flex"
                    onClick={openHelpModal}
                  >
                    <div className=" w-8 h-8 flex justify-center items-center mr-2 rounded-md">
                      <img src={helpIcon} alt="" className={` w-5 h-5`} />
                    </div>
                    <div className=" flex items-center h-8 font-medium text-sm">
                      {t("DIGITALCARD.help")}
                    </div>
                  </button>
                </div>
              </div>
            </section>
          </div>
        </PullToRefresh>
      </div>
      <Transition appear show={isHelpOpen} as={Fragment}>
        <Dialog as="div" className="relative z-10" onClose={closeHelpModal}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black bg-opacity-25" />
          </Transition.Child>

          <div className="fixed inset-0 overflow-y-auto">
            <div className="flex min-h-full items-center justify-center p-4 text-center">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-2xl bg-psp-primary p-6 text-left align-middle shadow-xl transition-all">
                  <Dialog.Title
                    as="h3"
                    className="text-lg font-medium leading-6 text-gray-900"
                  >
                    <div className="flex flex-row">
                      <img src={helpIcon} alt="" className="text-black mr-2" />
                      <div>{t("DIGITALCARD.help")}</div>
                    </div>
                  </Dialog.Title>
                  <div className="rounded-2xl bg-psp-primary mt-3 p-2">
                    <div className="">
                      <b>{t("DIGITALCARD.balanceCard")}</b> :{" "}
                      {t("DIGITALCARD.balanceCardDesc")}
                    </div>
                    <div>
                      <b>{t("DIGITALCARD.limitAccumulate")}</b> :{" "}
                      {t("DIGITALCARD.limitAccumulateDesc")}
                    </div>
                    <div>
                      <b>{t("DIGITALCARD.dailyLimit")}</b> :{" "}
                      {t("DIGITALCARD.limitDailyDesc")}
                    </div>
                  </div>
                  <div className="mt-4 flex flex-row justify-evenly">
                    <button
                      type="button"
                      className="w-full h-10 mr-1 rounded-md text-white bg-psp-btn-red"
                      onClick={closeHelpModal}
                    >
                      {t("DIGITALCARD.close")}
                    </button>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
      <Transition appear show={isOpen} as={Fragment}>
        <Dialog as="div" className="relative z-10" onClose={closeModal}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black bg-opacity-25" />
          </Transition.Child>

          <div className="fixed inset-0 overflow-y-auto">
            <div className="flex min-h-full items-center justify-center p-4 text-center">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-2xl bg-psp-primary p-6 text-left align-middle shadow-xl transition-all">
                  <Dialog.Title
                    as="h3"
                    className="text-lg font-medium leading-6 text-gray-900"
                  >
                    <div className="flex flex-row">
                      <img
                        src={settingIcon}
                        alt=""
                        className="text-black mr-2"
                      />
                      <div>{t("DIGITALCARD.setLimit")}</div>
                    </div>
                    <p className="text-sm text-red my-1">
                      {t("DIGITALCARD.adjustment")}
                    </p>
                  </Dialog.Title>
                  <div className="mt-2 hidden">
                    <p className="m-0">{t("DIGITALCARD.balanceCard")}</p>
                    <CurrencyInput
                      className="px-3 w-full rounded-xl h-10 border-1 border-psp-border-gray border-solid active:border-0"
                      placeholder="Rp.10.000"
                      decimalsLimit={2}
                      prefix={"Rp "}
                      value={numberOnly(cardBalance)}
                      onValueChange={(value, name) => {
                        console.log(value);
                        setCardBalance(value != undefined ? Number(value) : 0);
                      }}
                    />
                  </div>
                  <div className="mt-2">
                    <p className="m-0">{t("DIGITALCARD.limitAccumulate")}</p>
                    <CurrencyInput
                      className="px-3 w-full rounded-xl h-10 border-1 border-psp-border-gray border-solid active:border-0"
                      placeholder="Rp.10.000"
                      decimalsLimit={2}
                      prefix={"Rp "}
                      value={numberOnly(limitMax)}
                      onValueChange={(value, name) => {
                        console.log(value);
                        setLimitMax(value != undefined ? Number(value) : 0);
                      }}
                    />
                  </div>
                  <div className="mt-2">
                    <p className="m-0">{t("DIGITALCARD.dailyLimit")}</p>
                    <CurrencyInput
                      className="px-3 w-full rounded-xl h-10 border-1 border-psp-border-gray border-solid active:border-0"
                      placeholder="Rp.10.000"
                      decimalsLimit={2}
                      prefix={"Rp "}
                      value={numberOnly(daily)}
                      onValueChange={(value, name) => {
                        console.log(value);
                        setDaily(value != undefined ? Number(value) : 0);
                      }}
                    />
                  </div>
                  <div className="mt-2 flex flex-row justify-between">
                    <p className="m-0">{t("DIGITALCARD.transUnlimited")}</p>
                    <Switch
                      checked={isUnlimited}
                      onChange={setIsUnlimited}
                      className={`${
                        isUnlimited ? "bg-psp-btn-primary" : "bg-silver"
                      } relative inline-flex items-center h-6 rounded-full w-10 transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500`}
                    >
                      {/* <span
                        className={`${
                          isUnlimited ? "left-0" : "right-0"
                        } inline-block  transform bg-white rounded-full transition-transform`}
                      >
                      </span> */}
                      <span
                        aria-hidden="true"
                        className={`${
                          isUnlimited ? "translate-x-5" : "translate-x-0"
                        }
            pointer-events-none inline-block h-6 w-6 transform rounded-full bg-white shadow-lg ring-0 transition duration-200 ease-in-out`}
                      />
                    </Switch>
                  </div>

                  <div className="mt-4 flex flex-row justify-evenly">
                    <button
                      type="button"
                      className="w-full h-10 mr-1 rounded-md text-white bg-psp-btn-red"
                      onClick={closeModal}
                    >
                      {t("DIGITALCARD.cancel")}
                    </button>
                    <button
                      type="button"
                      className="w-full h-10 ml-1 rounded-md text-white bg-psp-btn-primary"
                      onClick={saveData}
                    >
                      {t("DIGITALCARD.save")}
                    </button>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </>
  );
};

export default CardMobile;
